import _ from 'lodash';

export function firstPromoToApply(promoCodes = [], opts = {}) {
  const bartender = forBartender(promoCodes);
  if (bartender && opts.bartender) return bartender;
  const expiring = firstToExpire(promoCodes);
  if (expiring) return expiring;
  else return highestValue(promoCodes);
}

function firstToExpire(promoCodes = []) {
  const withExpDate = promoCodes.filter(c => c.expDate && c.expDate.iso);
  const sorted = _.sortBy(withExpDate, c => c.expDate.iso);
  return sorted[0];
}

function highestValue(promoCodes = []) {
  const sorted = _.sortBy(promoCodes, c => c.val);
  return _.last(sorted);
}

function forBartender(promoCodes = []) {
  return _.find(promoCodes, c => c.label === 'BARTENDER');
}



// WEBPACK FOOTER //
// ./shared/models/promo.js